import axiosInstance from '../../../../../services/axios/axios';

//fetch IMS Log Data
export const fetchIMSLogs = async filterArgs => {
	try {
		const response = await axiosInstance.get(
			`api/IMSLogs/Index?filters=${filterArgs}`
		);

		return response;
	} catch (ex) {
		console.error('Unable to fetch IMSLogs: ' + ex);
		return {
			data: [],
			error: 'An Error Occured Fetching data from the server',
		};
	}
};

export const fetchSourceOptions = async () => {
	try {
		const response = await axiosInstance.get('api/IMSLogs/LogSources');

		return response;
	} catch (ex) {
		console.error('Unable to fetch IMSLogs: ' + ex);
		return {
			data: [],
			error: 'An Error Occured Fetching data from the server',
		};
	}
};

export const getLogByID = async id => {
	try {
		const response = await axiosInstance.get(
			`api/IMSLogs/Details?id=${id}`
		);
		return response.data;
	} catch (ex) {
		console.error(`unable to fetch IMSLog with id:${id}`);
		return { data: null, error: `unable to fetch IMSLog with id:${id}` };
	}
};
